import { useEffect, useRef, useState } from 'react'

import Footer from '../CommonComponents/Footer'
import { useStore } from '../../store'
import CustomList from '../CommonComponents/CustomList';
import BackHeader from '../CommonComponents/BackHeader';
import api from '../../api/apiClient';
import { endpoints } from '../../api/endpoints';
import { ArtistDataType, storeType} from '../../types';

export default function Artists() {
  const {store, updateStoreFunc} = useStore();

  const {scrollPos, page, hasMore, loading, data} = store.artists;

  const dataApi = useRef("");

  const controller = new AbortController();
  const signal = controller.signal;

  const fetchData = async () => {
    if(page === 1) updateStoreFunc('newSongs','loading',true);
    const result: any = await api.get(endpoints.common.search + `?current=${page}&limit=10&type=${'artist'}&keyword=`, {signal});
    dataApi.current = endpoints.common.search + `?current=${page + 1}&limit=30&type=${'artist'}&keyword=`;
    if(page === 1) updateStoreFunc('newSongs','loading', false);
    if(result.code === '200'){
      updateStoreFunc(null,null,null,(pre: storeType['store']) => {
        const d : ArtistDataType = result.data;
        let arr: any;
        let o = {...pre};
        let a: any = {...o.artists.data};
        if(page > 1){
          try{
            arr = [...a?.by,...d?.by]
            a.by = arr;
            o.artists.data = a;
            return o;
          }catch(err: any){
            console.log("forced exist error: ", err.message)
            return pre;
          }
        }else{
          a = d;
          o.artists.data = a;
          return o;
        }
      })
    }else{
      if(page > 1){
        updateStoreFunc('artists','hasMore',false);
      }else{
        updateStoreFunc('artists','hasMore',false);
        updateStoreFunc('artists','data',null)
      }
    }
  }
  
  
  const handleFetchMore = () => {
    updateStoreFunc('artists','page', page + 1)
  }
  
  const handleScroll = (event: any) => {
    const scrollTop = event.target.scrollTop;
    updateStoreFunc('artists','scrollPos',scrollTop);
  }
  
  useEffect(() => {
    fetchData();
  },[page])

  useEffect(() => {
    if(data?.by && data?.pagination){
      if(data?.by?.length === data?.pagination?.total) updateStoreFunc('artists','hasMore',false);
    }
  },[data])

  useEffect(() => {
    return () => {
      controller.abort();
      if(window.location.pathname === "/home"){
        updateStoreFunc('artists','data', null);
        updateStoreFunc('artists','hasMore', true);
        updateStoreFunc('artists','page', 1);
      }
    }
  }, [])

  return ( 
    <div>
      <BackHeader/>
      <div style={{padding: "0 15px"}}>
          <CustomList
            data={data}
            type={"Artist"}
            selectedTag='Artist'
            loading={loading}
            handleFetchMore={handleFetchMore}
            hasMore={hasMore}
            scrollHeight={store.screenHeight - 50}
            dataApi={dataApi.current}
            handleScroll={handleScroll}
            scrollPos={scrollPos}
          />
      </div>
      <Footer/>
    </div>
  )
}
